<template>
  <v-row class="pa-5" v-if="doc">
    <v-col cols="12">
      <h2>Service design summary</h2>
    </v-col>

    <v-col v-if="editTitle" cols="4" class="d-flex">
      <v-text-field
        label="Which group is this for?"
        v-model.trim="doc.stream"
        type="text"
        placeholder="Type here"
        id="title"
        class="title"
        required
        color="amber"
      >
      </v-text-field>
      <button @click="changeTitle()" class="pl-2">
        <v-icon>mdi-check</v-icon>
      </button>
    </v-col>
    <v-col v-else cols="3" class="">
      <h4>Journey type</h4>
      <div class="d-flex flex-row justify-space-between">
        <p class="mt-4">{{ doc.stream }}</p>
        <button @click="changeTitle()" class="pl-2">
          <v-icon>mdi-pencil</v-icon>
        </button>
      </div>
    </v-col>
    <v-col cols="3">
      <h4>Filter cards</h4>
      <v-select
        :items="categories"
        multiple
        label="Type"
        v-model="filters"
        required
      ></v-select>
    </v-col>
    <v-col cols="3">
      <h4>Controls</h4>
      <v-btn v-if="isAdmin" light color="amber mr-5 mt-4" @click="add"
        >Add</v-btn
      >
      <v-btn light color="white mr-5 mt-4" @click="toggleAllOpen"
        >Toggle Open</v-btn
      >
    </v-col>
    <v-col cols="12" class="pr-16">
      <SaveCanvas background="#000000">
        <div class="service">
          <div class="service__col">
            <p>Awareness</p>
            <draggable
              class="inner"
              :list="doc.list1"
              group="notes"
              @end="handleEnd"
            >
              <service-card-user
                class="list-group-item"
                v-for="element in filterListType(doc.list1)"
                :key="`awareness-${element.id}`"
                :card="element"
                :edit="true"
                :is-open="toggleOpen"
                @showNote="showNote('list1', $event)"
                @editNote="editNote('list1', $event)"
                @removeNote="removeNote('list1', $event)"
              >
              </service-card-user>
            </draggable>
          </div>
          <div class="service__col">
            <p>First interaction</p>
            <draggable
              class="inner"
              :list="doc.list2"
              group="notes"
              @end="handleEnd"
            >
              <service-card-user
                class="list-group-item"
                v-for="element in filterListType(doc.list2)"
                :key="`awareness-${element.id}`"
                :card="element"
                :edit="true"
                :is-open="toggleOpen"
                @showNote="showNote('list2', $event)"
                @editNote="editNote('list2', $event)"
                @removeNote="removeNote('list2', $event)"
              >
              </service-card-user>
            </draggable>
          </div>
          <div class="service__col">
            <p>Engagement</p>
            <draggable
              class="inner"
              :list="doc.list3"
              group="notes"
              @end="handleEnd"
            >
              <service-card-user
                class="list-group-item"
                v-for="element in filterListType(doc.list3)"
                :key="`awareness-${element.id}`"
                :card="element"
                :edit="true"
                :is-open="toggleOpen"
                @showNote="showNote('list3', $event)"
                @editNote="editNote('list3', $event)"
                @removeNote="removeNote('list3', $event)"
              >
              </service-card-user>
            </draggable>
          </div>
          <div class="service__col">
            <p>Return</p>
            <draggable
              class="inner"
              :list="doc.list4"
              group="notes"
              @end="handleEnd"
            >
              <service-card-user
                class="list-group-item"
                v-for="element in filterListType(doc.list4)"
                :key="`awareness-${element.id}`"
                :card="element"
                :edit="true"
                :is-open="toggleOpen"
                @showNote="showNote('list4', $event)"
                @editNote="editNote('list4', $event)"
                @removeNote="removeNote('list4', $event)"
              >
              </service-card-user>
            </draggable>
          </div>
          <div class="service__col">
            <p>Ambassadors</p>
            <draggable
              class="inner"
              :list="doc.list5"
              group="notes"
              @end="handleEnd"
            >
              <service-card-user
                class="list-group-item"
                v-for="element in filterListType(doc.list5)"
                :key="`awareness-${element.id}`"
                :card="element"
                :edit="true"
                :is-open="toggleOpen"
                @showNote="showNote('list5', $event)"
                @editNote="editNote('list5', $event)"
                @removeNote="removeNote('list5', $event)"
              >
              </service-card-user>
            </draggable>
          </div>
        </div>
      </SaveCanvas>
      <div class="service__tray">
        <p>All</p>
        <draggable
          class="inner"
          :list="filterListType(doc.all)"
          group="notes"
          @end="handleEnd"
        >
          <service-card-user
            class="list-group-item"
            v-for="element in doc.all"
            :key="`all-${element.id}`"
            :card="element"
            :edit="true"
            @showNote="showNote('all', $event)"
            @editNote="editNote('all', $event)"
            @removeNote="removeNote('all', $event)"
          >
          </service-card-user>
        </draggable>
      </div>
    </v-col>

    <v-dialog v-model="dialog" max-width="500">
      <v-card v-if="mode === 'show'">
        <v-card-text class="pa-10">
          <service-show-user
            v-model="item"
            :key="cardId"
            @complete="closeDialog"
          />
        </v-card-text>
      </v-card>
      <v-card light v-else-if="mode === 'edit'">
        <service-form :doc="item" />

        <v-btn light color="amber mr-5" @click="saveEdit">Submit</v-btn>
      </v-card>
      <v-card light v-else-if="mode === 'add'">
        <service-form :doc="item" />
        <v-btn light color="amber mr-5" @click="saveAdd">Submit</v-btn>
      </v-card>
      <v-card light v-else-if="mode === 'delete'">
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="saveRmove"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import lodash from "lodash";
import draggable from "vuedraggable";

const fb = require("@/firebaseConfig.js");

const defaults = {
  title: "",
  categories: [],
  subitems: [],
  model: "all",
  description: "",
};

import {
  ServiceCardUser,
  ServiceShowUser,
  ServiceForm,
} from "@/views/user/exercises/service";

import { SaveCanvas } from "@/components/core";
import { mapState } from "vuex";

export default {
  name: "ResultsServiceSummary",
  data() {
    return {
      doc: null,
      docId: null,
      refDoc: null,
      items: [],
      dialog: false,
      docStream: "",
      cardIndex: "",
      cardModel: "",
      cardId: "",
      item: {},
      mode: "hide",
      editTitle: false,
      toggleOpen: false,
      filters: [],
      categories: [
        "Digital",
        "Physical",
        "Logistics",
        "Bottleneck",
        "Opportunity",
      ],
    };
  },
  props: {
    uid: String,
    id: String,
  },
  mounted() {
    this.getExercise();
  },
  components: {
    ServiceCardUser,
    ServiceShowUser,
    ServiceForm,
    SaveCanvas,
    draggable,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
    },
  },
  methods: {
    toggleAllOpen() {
      this.toggleOpen = !this.toggleOpen;
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.serviceExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.doc = items[0].doc;
        this.docId = items[0].id;
        this.docStream = items[0].docStream;
      });
    },
    changeTitle() {
      this.editTitle = !this.editTitle;
      if (this.editTitle === false) {
        this.saveExercise();
      }
    },
    saveExercise() {
      const updateRef = fb.serviceExCollection.doc(this.docId);
      console.log({
        updatedOn: new Date(),
        id: this.docId,
        uid: this.uid,
        pid: this.id,
        doc: this.doc,
      });
      updateRef
        .set({
          updatedOn: new Date(),
          id: this.docId,
          uid: this.uid,
          pid: this.id,
          doc: this.doc,
        })
        .then(() => {
          console.log("saved item");
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    showNote($event, params) {
      const item = this.doc[$event].find((x) => x.id === params);
      this.cardIndex = this.doc[$event].indexOf(item);
      this.cardId = params;
      this.cardModel = $event;
      this.item = Object.assign({}, item);
      this.mode = "show";
      this.dialog = true;
    },
    cancel() {
      this.closeDialog();
    },
    add($event) {
      this.item = defaults;
      this.editMode = false;
      this.cardModel = $event;
      this.newMode = true;
      this.dialog = true;
      this.mode = "add";
    },
    saveAdd() {
      this.item.id = Math.floor(Math.random() * 1000000 + 1);
      this.doc[this.item.model].push(this.item);
      this.saveExercise();
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
      this.item = { ...defaults };
      this.cardId = null;
      this.mode = "hide";
      this.cardModel = null;
    },
    editNote($event, params) {
      const item = this.doc[$event].find((x) => x.id === params);
      this.cardIndex = this.doc[$event].indexOf(item);

      this.cardId = params;
      this.cardModel = $event;
      this.item = Object.assign({}, item);
      this.mode = "edit";
      this.dialog = true;
    },
    saveEdit() {
      if (this.cardModel !== this.item.model) {
        // move the current item
        this.item.id = this.doc[this.item.model].length;
        this.doc[this.item.model].push(this.item);
        // remove the old one
        this.doc[this.cardModel].splice(this.cardIndex, 1);
      } else {
        this.$set(this.doc[this.cardModel], this.cardIndex, this.item);
      }
      this.saveExercise();
      this.closeDialog();
    },
    removeNote($event, params) {
      const item = this.doc[$event].find((x) => x.id === params);
      this.cardIndex = this.doc[$event].indexOf(item);
      this.cardId = params;
      this.cardModel = $event;
      this.mode = "delete";
      this.dialog = true;
    },
    saveRmove() {
      this.doc[this.cardModel].splice(this.cardIndex, 1);
      this.saveExercise();
      this.closeDialog();
    },
    handleEnd() {
      console.log("handle End");
      this.saveExercise();
    },
    filterListType(list) {
      const arr = [...list];
      const match = arr.filter((x) => x.categories.includes(this.filters));
      return match;
    },
  },
};
</script>
